import { render, staticRenderFns } from "./TableType3.vue?vue&type=template&id=c6a91602&"
import script from "./TableType3.vue?vue&type=script&lang=js&"
export * from "./TableType3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports